"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshTwoFA = exports.getTwoFATokenData = exports.confirmTwoFA = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _utils = require("@package/utils");

var _request = _interopRequireDefault(require("@package/request"));

var _dialog = require("@package/dialog");

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _slice = require("../slice");

var confirmTwoFA = function confirmTwoFA(uuid, formData, tokenId) {
  var isFile = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var payout;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на подтверждение TwoFA по выплаты с id: ' + uuid
              });
              dispatch((0, _slice.confirmTwoFARequestAction)());
              _context.next = 5;
              return (0, _request["default"])({
                url: "/v2/two-fa/".concat(uuid, "/auth"),
                method: 'put',
                data: formData
              });

            case 5:
              payout = _context.sent;
              dispatch((0, _slice.confirmTwoFARequestSuccessAction)(payout));
              dispatch((0, _dialog.closeDialog)('confirm-twoFA'));
              dispatch(notifications.pushSuccess('Операция успешно выполнена'));
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'TwoFa успешно подтвержден по выплате с id: ' + uuid
              });
              _context.next = 20;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", void 0);

            case 16:
              dispatch(getTwoFATokenData(tokenId, isFile));
              dispatch((0, _slice.confirmTwoFARequestFailAction)(_context.t0['data']));
              dispatch(notifications.pushFail(_context.t0['data']));
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при запросе на подтверждение TwoFA по выплате с id: ' + uuid
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.confirmTwoFA = confirmTwoFA;

var refreshTwoFA = function refreshTwoFA(uuid) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(dispatch) {
      var _yield$request, data;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на получение нового TwoFA по выплате с id: ' + uuid
              });
              dispatch((0, _slice.refreshTwoFARequestAction)());
              _context2.next = 5;
              return (0, _request["default"])({
                url: "/v2/two-fa/refresh",
                method: 'post',
                data: {
                  uuid: uuid,
                  externalId: (0, _utils.UUID)()
                }
              });

            case 5:
              _yield$request = _context2.sent;
              data = _yield$request.data;
              dispatch((0, _slice.refreshTwoFARequestSuccessAction)(data));
              dispatch(notifications.push({
                title: 'Новый код подтверждения',
                content: 'Мы выслали повторно код на Ваш телефон',
                mode: 'success',
                autoClose: true
              }));
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Новый TwoFA сформирован'
              });
              return _context2.abrupt("return", data);

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0 instanceof _errors.UnauthorizedError)) {
                _context2.next = 17;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 17:
              dispatch((0, _slice.refreshTwoFARequestFailAction)(_context2.t0['data']));
              dispatch(notifications.pushFail(_context2.t0['data']));
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при запросе на получение навого TwoFA'
              });

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 13]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.refreshTwoFA = refreshTwoFA;

var getTwoFATokenData = function getTwoFATokenData(externalId) {
  var isFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(dispatch) {
      var url, _yield$request2, data, _error$data$code, _error$data;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              (0, _logger.push)({
                message: 'Запрос на получение 2FA'
              });
              dispatch((0, _slice.getTokenDataRequestAction)());
              url = isFile ? "/two-fa/".concat(externalId) : "/payouts/".concat(externalId, "/token");
              _context3.next = 6;
              return (0, _request["default"])({
                url: url,
                method: 'get'
              });

            case 6:
              _yield$request2 = _context3.sent;
              data = _yield$request2.data;
              dispatch((0, _slice.getTokenDataRequestSuccessAction)(data));
              _context3.next = 18;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);

              if (!(_context3.t0 instanceof _errors.UnauthorizedError)) {
                _context3.next = 15;
                break;
              }

              return _context3.abrupt("return", void 0);

            case 15:
              dispatch((0, _slice.getTokenDataRequestFailAction)(_context3.t0['data']));
              dispatch(notifications.push({
                title: 'Ошибка при получении данных',
                content: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 (\u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ".concat((_error$data$code = _context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_error$data = _context3.t0['data']) === null || _error$data === void 0 ? void 0 : _error$data['code']) !== null && _error$data$code !== void 0 ? _error$data$code : _context3.t0['message'], ")"),
                mode: 'danger',
                autoClose: false
              }));
              (0, _logger.push)({
                message: 'Ошибка при запросе на получение 2FA'
              });

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 11]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.getTwoFATokenData = getTwoFATokenData;